import NotSoSimpleMarkdown from 'simple-markdown'

// Setup NotSoSimpleMarkdown
// Here's a whitelistof things we accept in our markdown string
const markdownRules = {
  list: NotSoSimpleMarkdown.defaultRules.list,
  paragraph: NotSoSimpleMarkdown.defaultRules.paragraph,
  link: {
    ...NotSoSimpleMarkdown.defaultRules.link,

    react: function (node: any, output: any, state: any) {
      const url = NotSoSimpleMarkdown.sanitizeUrl(node.target)
      const target = url && /url=mailto/.test(url) ? '' : '_blank'
      return (
        <a key={state.key} href={url} target={target} rel="noopener noreferrer" title={node.title}>
          {output(node.content, state)}
        </a>
      )
    }
  },
  em: NotSoSimpleMarkdown.defaultRules.em,
  escape: NotSoSimpleMarkdown.defaultRules.escape,
  strong: NotSoSimpleMarkdown.defaultRules.strong,
  text: NotSoSimpleMarkdown.defaultRules.text,
  strongUnderline: {
    ...NotSoSimpleMarkdown.defaultRules.strong,
    match: NotSoSimpleMarkdown.inlineRegex(/^__([\s\S]+?)__(?!_)/)
  },
  // We no longer allow images inline with text (use the image component)
  // image: NotSoSimpleMarkdown.defaultRules.image,
  icon: {
    order: NotSoSimpleMarkdown.defaultRules.em.order - 0.5,
    match: NotSoSimpleMarkdown.inlineRegex(/^\{{2}ICON\((\w+)(?:,\s*(#?\w+))?(?:,\s*(#?\w+))?\)\}{2}/i),
    parse: function (capture: any, parse: any, state: any) {
      // TODO Some logic around if the state color exists (state.color comes from a textblock CSS)
      const stateColor = state.style && state.style.color
      return {
        iconName: capture[1],
        fillColor: stateColor || capture[2],
        strokeColor: stateColor || capture[3]
      }
    },

    react: function (node: any, output: any, state: any) {
      // The styles for an "Icon" are set here
      const iconStyles = {
        height: '1em',
        width: '1em',
        fill: node.fillColor,
        stroke: node.strokeColor,
        marginRight: 2
      }
      return (
        <svg key={state.key} style={iconStyles}>
          <use xlinkHref={`#inline-icon-${node.iconName}`} />
        </svg>
      )
    }
  }
}

// Create the parser with these rules
const rawBuiltParser = NotSoSimpleMarkdown.parserFor(markdownRules)
const parse = (source: any) => {
  const blockSource = source + '\n\n'
  return rawBuiltParser(blockSource, { inline: false })
}
const reactOutput = NotSoSimpleMarkdown.reactFor(NotSoSimpleMarkdown.ruleOutput(markdownRules, 'react'))

export default function processMarkdown(text: any) {
  // Shortcut for empty text
  if (!text) {
    return null
  }
  const parseTree = parse(text)
  return reactOutput(parseTree)
}
